<div class="modal-content loader-parent revert-split-container">
    <div class="page-loader" [ngClass]="{'d-none': !isLoading && !isMerging}"></div>

    <div class="modal-header">
        <h4 class="modal-title">Merge Split Stock</h4>
    </div>
    <div class="modal-body">
        <div class="quotes-model-inner" [class.is-loading]="isLoading">
            <ng-container *ngIf="!isLoading">

                <p class="merge-source-line" *ngIf="source">
                    Merging line <strong>{{ source.label }}</strong> ({{ sourceQtyLabel }} · {{ source.location }}<span
                        *ngIf="showSrd"> · SRD {{ source.srd ? (source.srd | date: 'dd/MM/yyyy') : '-' }}</span>)
                    into the line you select below.
                </p>

                <p class="revert-empty-msg" *ngIf="!source">
                    This line is not a split line, so there is nothing to merge.
                </p>
                <p class="revert-empty-msg" *ngIf="source && targets.length === 0">
                    No line is available to merge into - every other line of this product is already in a
                    delivery stage.
                </p>

                <div class="split-list" *ngIf="targets.length > 0">
                    <div class="split-list-col-header">
                        <span class="col-header-checkbox-spacer"></span>
                        <span class="col-header-qty">Line</span>
                        <span class="col-header-srd" *ngIf="showSrd">SRD</span>
                        <span class="col-header-status">Status</span>
                    </div>

                    <div *ngFor="let line of targets"
                        class="split-list-row"
                        [class.row-selected]="selectedTargetId === line.id"
                        (click)="selectTarget(line.id)">

                        <div class="custom-radio-box row-radio" (click)="$event.stopPropagation()">
                            <input
                                type="radio"
                                name="merge-target"
                                [id]="'merge-target-' + line.id"
                                [checked]="selectedTargetId === line.id"
                                [disabled]="isMerging"
                                (change)="selectTarget(line.id)"
                            />
                            <label [attr.for]="'merge-target-' + line.id"></label>
                        </div>

                        <div class="row-info">
                            <span class="row-label">{{ line.label }}</span>
                            <span class="row-qty">
                                {{ line.quantity }}
                                @if (uom === 'SQM') {
                                    m<sup>2</sup>
                                } @else {
                                    {{ uom }}
                                }
                            </span>
                            <span class="row-location">{{ line.location }}</span>
                        </div>

                        <!-- Only rendered when the lines differ on SRD (split-delivery orders),
                             where it is often the only thing distinguishing two lines. -->
                        <span class="row-srd" *ngIf="showSrd">{{ line.srd ? (line.srd | date: 'dd/MM/yyyy') : '-' }}</span>

                        <span class="status-flag"
                            [ngClass]="line.status_quote_product?.name ? toKebabCase(line.status_quote_product.name) : 'status-unassigned'">
                            {{ line.status_quote_product?.name || 'Unassigned' }}
                        </span>
                    </div>
                </div>

                <p class="merge-result-line" *ngIf="mergedQty !== null">
                    After merging, that line will hold <strong>{{ mergedQty }}{{ unitLabel ? ' ' + unitLabel : '' }}</strong>.
                    <span *ngIf="consumableTotal !== null">
                        Consumables will be recalculated for that full quantity
                        (<strong>{{ consumableTotal | currency }}</strong>).
                    </span>
                </p>

                <!-- One of the two lines carries a consumable the other does not. There is nothing to
                     decide here: the merge applies it across the whole merged quantity, the same as
                     every other consumable on the line. This is shown so that is understood. -->
                <div class="consumable-mismatch" *ngIf="hasConsumableMismatch && !isPreviewLoading">
                    <p class="consumable-mismatch-title">
                        <i class="fa fa-exclamation-triangle"></i>
                        {{ mismatchedLabels }} {{ mismatchedIsPlural ? 'are' : 'is' }} on only one of these two lines.
                    </p>
                    <p class="consumable-mismatch-body">
                        Merging applies {{ mismatchedIsPlural ? 'them' : 'it' }} across the whole
                        <strong>{{ preview?.merged_quantity }}{{ unitLabel ? ' ' + unitLabel : '' }}</strong>,
                        including the quantity that does not carry {{ mismatchedIsPlural ? 'them' : 'it' }} today.
                        <span *ngIf="consumableTotal !== null">The consumable figure above already includes this.</span>
                    </p>
                </div>

                <p class="merge-error" *ngIf="errorMessage">{{ errorMessage }}</p>
            </ng-container>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-cancel" (click)="activeModal.dismiss()" [disabled]="isMerging">Cancel</button>
        <button
            type="button"
            class="btn btn-submit"
            [disabled]="selectedTargetId === null || isMerging"
            (click)="merge()"
        >
            Merge
        </button>
    </div>
</div>
